<template>
  <div class="commont-box">
    <div class="footer-content commont-content">
      <a-row>
        <a-col span="8">
          <p class="footer-text">Products</p>
          <p class="footer-text">
            Structure FEA
            <a-divider type="vertical" style="background-color: #fff" />
            Revit plugin
            <a-divider type="vertical" style="background-color: #fff" />
            Rebar Detailing
          </p>
        </a-col>
        <a-col span="8">
          <p class="footer-text">
            <!-- <a href="http://www.toolkip.com/" target="_blank">企业官网</a> -->
          </p>
        </a-col>
        <a-col span="8">
          <p class="footer-text">Contact US</p>
          <p class="footer-text">                    
          <a-space size="large">
          <a target=_blank href="https://www.facebook.com/digirebar?mibextid=wwXIfr&mibextid=wwXIfr"><img width=80 src="@/assets/facebook.png" alt="" class="logo-img" /></a>
          <a target=_baank href="mailto:qianx768@gmail.com"><img width=80 src="@/assets/gmail.png" alt="" class="logo-img" /></a>
          
        </a-space>
          </p>
          <p class="footer-text"><a><MailOutlined />&nbsp;&nbsp;qianx768@gmail.com</a></p>
        </a-col>
        <a-col span="24">
          <p class="footer-conpyright">
            Copyright Digirebar Limited HongKong
          </p>
        </a-col>
      </a-row>
    </div>
  </div>
  <AboutUs ref="aboutUs" />
</template>

<script>
import { ref } from "vue";
import AboutUs from "@/views/home/AboutUs.vue";
export default {
  name: "HomeFooter",
  components: {
    AboutUs,
  },
  setup() {
    const aboutUs = ref(null);
//window.open("https://wa.me/8613651872393");
    const aboutMe = () => {
      aboutUs.value.showModal();
    };

    return {
      aboutUs,
      aboutMe,
    };
  },
};
</script>

<style lang="less" scoped>
.commont-box {
  width: 100%;
  background-color: #1890ff;
  margin-top: 20px;
}
.commont-content {
  max-width: 1200px;
  margin: 0 auto;
}
.footer-content {
  padding: 20px 0;
  .footer-text {
    color: #fff;

    a {
      color: #fff;
    }

    a:hover {
      color: #000;
    }
  }
  .footer-conpyright {
    .px2vh(margin-top, 16);
    text-align: center;
    margin-bottom: 0;
  }
}
</style>